module.exports = __webpack_public_path__ + "static/media/moto_1.1daec567.png";